<div class="nav_wrap">
  <nav #appHeader class="navbar navbar-expand-lg navbar-dark fixed-top my-navbar bg-dark">
    <div class="container-fluid header-bar">
      <div class="menu-button-wrap">
        <button type="button" class="btn btn-link menu-toggle hamburger text-white" (click)="toggleSidebar()" aria-label="Menu">
          <span class="navbar-toggler-icon"></span>
        </button>
      </div>
      <div class="navlogo-wrap">
        <a routerLink="/">
          <img class="nav-house" alt="Brand" src="/Images/RevWhite_HorizontalArcxis.png" />
        </a>
      </div>
      @if (session.isLoggedIn() && loginName) {
        <div class="header-login-name">{{ loginName }}</div>
      }
    </div>
  </nav>
</div>

<div id="wrapper">
  <div id="sidebar-wrapper">
    <ul class="sidebar-nav">
      @if (showMainMenu()) {
        <li>
          <a href="#" (click)="$event.preventDefault(); toMainMenu()" class="menu-toggle">Main Menu</a>
        </li>
      }
      @if (isIPPayInspectorUser()) {
        <li>
          <a href="#" (click)="$event.preventDefault(); toIPPaymentHistory()" class="menu-toggle">Pay History</a>
        </li>
      }
      @if (session.isLoggedIn() && isAM()) {
        <li>
          <a routerLink="/settings/profile" class="menu-toggle" (click)="toggleSidebar()">Settings</a>
        </li>
      }
      @if (isEngineering()) {
        <li>
          <a href="#" (click)="$event.preventDefault(); toAddressPlans()" class="menu-toggle">Address Plans</a>
        </li>
        <li>
          <a href="#" (click)="$event.preventDefault(); toDpisPlanVault()" class="menu-toggle">DPIS Plan Vault</a>
        </li>
      }
      @if (!session.isLoggedIn()) {
        <li>
          <a href="#" class="menu-toggle" (click)="$event.preventDefault(); login()">Log In</a>
        </li>
      }
      @if (session.isLoggedIn()) {
        <li>
          <a href="#" class="menu-toggle" (click)="$event.preventDefault(); logout()">Log Out</a>
        </li>
      }
    </ul>
  </div>
</div>

<div #viewWrap class="ui-view-wrap" (click)="closeSidebarIfOpen()">
  <router-outlet />
</div>

<a href="javascript:void(0)" id="return-to-top" (click)="scrollTop()">
  <i class="icon-chevron-up"></i>
</a>
